import { relativeTime } from "../utils/relativeTime";

export const initials = (name: string | null, email: string) => {
  const base = (name || email).trim();
  const parts = base.split(/[\s@.]+/).filter(Boolean);
  return ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase() || "?";
};

export const fmtDate = (iso: string | null) =>
  iso ? new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }) : "—";

const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

/** "2 hours ago" within the last week, the date before that. A stamp the
 * server wrote a moment ago can read as future on a browser clock running a few
 * seconds slow, so it is held at "now". */
export const fmtWhen = (iso: string) => {
  const now = Math.max(Date.now(), Date.parse(iso));
  return now - Date.parse(iso) < WEEK_MS ? relativeTime(iso, now) : fmtDate(iso);
};

export const currencySymbol = (code: string) =>
  ({ usd: "$", gbp: "£", eur: "€" }[code?.toLowerCase()] || `${code} `);
